export var OTPType;
(function (OTPType) {
    OTPType["OTP_DISABLED"] = "OTP_DISABLED";
    OTPType["OTP_GA"] = "OTP_GA";
    OTPType["OTP_EMAIL"] = "OTP_EMAIL";
})(OTPType || (OTPType = {}));
//# sourceMappingURL=types.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@unitedtraders/keycloak/es/types.js
// module id = 732
// module chunks = 118